export const SUBSCRIPTION_STATUSES = {
  subscribed: 'SUBSCRIBED',
  notSubscribed: 'NOT_SUBSCRIBED',
};

export const SF_SUBSCRIPTION_STATUSES = {
  optedIn: 'OPTED_IN',
  optedOut: 'OPTED_OUT',
  notSubscribed: 'NOT_SUBSCRIBED',
}
